/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Typography,
  Tabs,
  Tab,
  Box,
  Button,
  Switch,
} from '@material-ui/core';
import { CloudDownload } from '@material-ui/icons';
import companyServices from '../../redux/services/companyServices';
import { Loading } from '../../helpers/utils';
import AdminData from './components/AdminData';
import PedagogicData from './components/PedagogicData';
import Semesters from './components/Semesters';
import Exams from './components/Exams';
import Criterias from './components/Criterias';
import exportCompanyData from './components/export';
import Ponderation from './components/Ponderation';
import useSemester from './components/Semesters/useSemester';
import Evaluo from './components/Evaluo';
import evaluoServices from '../../redux/services/evaluoServices';
import companyActions from '../../redux/actions/companyActions';
import { toastError } from '../../redux/actions/alertActions';

function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, padding: '0px' }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const PersonalInformations = ({ company, getCompany }) => {
  const [loading, setLoading] = useState(true);
  const [activatedEvaluo, setActivatedEvaluo] = useState(false);
  const [type, setType] = useState('');
  const [value, setValue] = React.useState(0);
  const [ponderation, setPonderation] = useState(false);
  const { updateCompanyDataPonderation } = useSemester(company._id, {}, () => {}, type);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    companyServices.getCompanyById(company._id)
      .then((companyRes) => {
        if (companyRes.activatedEvaluo) {
          setActivatedEvaluo(true);
        }
        companyServices.getCompanyDataById(company._id)
          .then((res) => {
            if (res.adminData && res.adminData.type) {
              setType(res.adminData.type);
            }
            if (res.ponderation) {
              setPonderation(res.ponderation);
            }
            setLoading(false);
          });
      })
      .catch((e) => {
        toastError('Failed to get company');
      });
  }, []);

  const updatePonderation = (checked) => {
    setPonderation(checked);
    updateCompanyDataPonderation(checked);
  };
  const updateEvaluoStatus = async () => {
    setActivatedEvaluo(!activatedEvaluo);
    await evaluoServices.updateCompanyEvaluoStatus(company._id, !activatedEvaluo);
  };

  return (
    <div>
      {loading === false
        ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            {company.type === '2' && (
            <Box
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                marginLeft: '15px',
              }}
            >
              <Typography
                variant="body1"
              >
                Evaluo
              </Typography>
              <Switch
                checked={activatedEvaluo}
                onChange={updateEvaluoStatus}
              >
                Evaluo
              </Switch>
            </Box>
            )}
            <Container>
              <Box sx={{
                borderBottom: 1,
                borderColor: 'divider',
                width: '100%',
                padding: '0px !important',
                display: 'flex',
                justifyContent: 'center',
              }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  <Tab
                    label="Administratif"
                    {...a11yProps(0)}
                  />
                  <Tab
                    label="Pédagogie"
                    {...a11yProps(1)}
                  />
                  <Tab
                    label="Semestres"
                    {...a11yProps(2)}
                  />
                  <Tab
                    label="Examens"
                    {...a11yProps(3)}
                  />
                  <Tab
                    label="Critères"
                    {...a11yProps(4)}
                  />
                  {ponderation
                  && (
                    <Tab
                      label="Pondération"
                      {...a11yProps(5)}
                    />
                  )}
                  {activatedEvaluo && (
                  <Tab
                    label="Evaluo"
                    {...a11yProps(6)}
                  />
                  )}
                </Tabs>
                <Button
                  onClick={() => exportCompanyData(company._id)}
                  variant="outlined"
                  color="primary"
                  endIcon={<CloudDownload />}
                  style={{ marginRight: '17px', marginLeft: '15px' }}
                >
                  Download
                </Button>
              </Box>
              <TabPanel value={value} index={0} sx={{ padding: '0px' }}>
                <AdminData setType={setType} />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <PedagogicData />
              </TabPanel>
              <TabPanel value={value} index={2}>
                <Semesters updatePonderation={updatePonderation} ponderation={ponderation} />
              </TabPanel>
              <TabPanel value={value} index={3}>
                <Exams />
              </TabPanel>
              <TabPanel value={value} index={4}>
                <Criterias type={type} />
              </TabPanel>
              <TabPanel value={value} index={5}>
                <Ponderation />
              </TabPanel>
              {activatedEvaluo && (
              <TabPanel value={value} index={6}>
                <Evaluo />
              </TabPanel>
              )}
            </Container>
          </div>
        )
        : <Loading />}
    </div>
  );
};

PersonalInformations.propTypes = {
  company: PropTypes.object.isRequired,
  getCompany: PropTypes.func.isRequired,
};

const actionCreators = {
  getCompany: companyActions.getCompany,
};

function mapState(state) {
  const { company } = state.company;
  return { company };
}

const connectedPersonalInformations = connect(mapState, actionCreators)(PersonalInformations);

export default withRouter(connectedPersonalInformations);
